import React from "react";
import { Link } from "react-router-dom";

const Tile = (props) => {
    const type = props.type || "info";
    const icon = props.icon || "fa fa-user";
    const header = props.header || "...";
    const description = props.description || "";
    const linkText = props.linkText || "More info";
    const linkNavigateTo = props.linkNavigateTo || "/";

    // Define AdminLTE3 original colors with 10% lighter gradient (NW to SE)
    const gradientMap = {
        danger: "linear-gradient(135deg, #e04958 0%, #dc3545 100%)",
        warning: "linear-gradient(135deg, #ffc720 0%, #ffc107 100%)",
        success: "linear-gradient(135deg, #3eb058 0%, #28a745 100%)",
        primary: "linear-gradient(135deg, #3d88ff 0%, #007bff 100%)",
        info: "linear-gradient(135deg, #2eabbf 0%, #17a2b8 100%)",
    };

    const backgroundGradient = gradientMap[type] || gradientMap.info;

    return (
        <div className="col-lg-3 col-6" style={{ padding: "12px" }}>
            <div
                className="small-box"
                style={{
                    height: "170px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    borderRadius: "6px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    padding: "18px 0 0 0",
                    fontFamily: "inherit",
                    background: backgroundGradient,
                    color: "#fff",
                }}
            >
                <div style={{ padding: "0 16px" }}>
                    <div className="inner" style={{ marginBottom: "8px" }}>
                        <span
                            style={{
                                fontSize: "50px",
                                fontWeight: 600,
                                margin: "0 0 6px 0",
                                letterSpacing: "1px",
                                fontFamily: "inherit",
                            }}
                        >
                            {header}
                        </span>
                        <span
                            className="text-small"
                            style={{
                                fontSize: "15px",
                                marginBottom: "4px",
                                display: "block",
                                fontFamily: "inherit",
                                color: "#fff",
                            }}
                        >
                            {description}
                        </span>
                    </div>
                    <div
                        className="icon"
                        style={{
                            fontSize: "32px",
                            color: "#fff",
                            opacity: 0.5,
                        }}
                    >
                        <i className={icon} />
                    </div>
                </div>
                <Link
                    to={linkNavigateTo}
                    className="small-box-footer"
                    style={{
                        marginTop: "auto",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "0 0 6px 6px",
                        padding: 0,
                        color: "rgba(255, 255, 255, 0.9)",
                        fontWeight: 500,
                        textDecoration: "none",
                        fontSize: "15px",
                        letterSpacing: "0.5px",
                        fontFamily: "inherit",
                        minHeight: "38px",
                        height: "38px",
                        backgroundColor: "rgba(0, 0, 0, 0.15)",
                        transition: "background-color 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "rgba(0, 0, 0, 0.25)")
                    }
                    onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "rgba(0, 0, 0, 0.08)")
                    }
                >
                    {linkText}&nbsp;
                    <i className="fas fa-arrow-circle-right" />
                </Link>
            </div>
        </div>
    );
};

export default Tile;
